// extracted by mini-css-extract-plugin
module.exports = {"container":"ReCaptcha_container__VgBjh"};